import { __decorate } from 'tslib';
import { EventEmitter, ViewChild, Input, Output, Component, forwardRef, ChangeDetectionStrategy, NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as editor from 'jsoneditor';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';

import * as ɵngcc0 from '@angular/core';

const _c0 = ["jsonEditorContainer"];
class JsonEditorOptions {
    constructor() {
        this.enableSort = true;
        this.enableTransform = true;
        this.escapeUnicode = false;
        this.expandAll = false;
        this.sortObjectKeys = false;
        this.history = true;
        this.mode = 'tree';
        this.search = true;
        this.indentation = 2;
    }
}

var JsonEditorComponent_1;
let JsonEditorComponent = JsonEditorComponent_1 = class JsonEditorComponent {
    constructor() {
        this.id = 'angjsoneditor' + Math.floor(Math.random() * 1000000);
        this.disabled = false;
        this.isFocused = false;
        this.optionsChanged = false;
        this._data = {};
        this.options = new JsonEditorOptions();
        this.debug = false;
        this.change = new EventEmitter();
        this.jsonChange = new EventEmitter();
        // Implemented as part of ControlValueAccessor.
        this.onTouched = () => {
        };
        // Implemented as part of ControlValueAccessor.
        this.onChangeModel = (e) => {
        };
    }
    set data(value) {
        this._data = value;
        if (this.editor) {
            this.editor.destroy();
            this.ngOnInit();
        }
    }
    ngOnInit() {
        let optionsBefore = this.options;
        if (!this.optionsChanged && this.editor) {
            optionsBefore = this.editor.options;
        }
        if (!this.options.onChangeJSON && this.jsonChange) {
            this.options.onChangeJSON = this.onChangeJSON.bind(this);
        }
        if (!this.options.onChange && this.change) {
            this.options.onChange = this.onChange.bind(this);
        }
        const optionsCopy = Object.assign({}, optionsBefore);
        // expandAll is an option only supported by ang-jsoneditor and not by the the original jsoneditor.
        delete optionsCopy.expandAll;
        if (this.debug) {
            console.log(optionsCopy, this._data);
        }
        if (!this.jsonEditorContainer.nativeElement) {
            console.error(`Can't find the ElementRef reference for jsoneditor)`);
        }
        this.editor = new editor(this.jsonEditorContainer.nativeElement, optionsCopy, this._data);
        if (this.options.expandAll) {
            this.editor.expandAll();
        }
    }
    /**
     * ngModel
     * ControlValueAccessor
     */
    // ControlValueAccessor implementation
    writeValue(value) {
        this.data = value;
    }
    // Implemented as part of ControlValueAccessor
    registerOnChange(fn) {
        this.onChangeModel = fn;
    }
    // Implemented as part of ControlValueAccessor.
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    // Implemented as part of ControlValueAccessor.
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onChange(e) {
        if (this.editor) {
            this.onChangeModel(this.editor.get());
            this.change.emit(this.editor.get());
        }
    }
    onChangeJSON(e) {
        if (this.editor) {
            this.jsonChange.emit(this.editor.get());
        }
    }
    /**
     * JSON EDITOR FUNCTIONS
     */
    collapseAll() {
        this.editor.collapseAll();
    }
    expandAll() {
        this.editor.expandAll();
    }
    focus() {
        this.editor.focus();
    }
    get() {
        return this.editor.get();
    }
    getMode() {
        return this.editor.getMode();
    }
    getName() {
        return this.editor.getName();
    }
    getText() {
        return this.editor.getText();
    }
    set(json) {
        this.editor.set(json);
    }
    setMode(mode) {
        this.editor.setMode(mode);
    }
    setName(name) {
        this.editor.setName(name);
    }
    setSelection(start, end) {
        this.editor.setSelection(start, end);
    }
    getSelection() {
        return this.editor.getSelection();
    }
    getValidateSchema() {
        return this.editor.validateSchema;
    }
    setSchema(schema) {
        this.editor.setSchema(schema);
    }
    search(query) {
        this.editor.search(query);
    }
    setOptions(newOptions) {
        if (this.editor) {
            this.editor.destroy();
        }
        this.optionsChanged = true;
        this.options = newOptions;
        this.ngOnInit();
    }
    update(json) {
        this.editor.update(json);
    }
    destroy() {
        this.editor.destroy();
    }
    isValidJson() {
        try {
            JSON.parse(this.getText());
            return true;
        }
        catch (e) {
            return false;
        }
    }
};
JsonEditorComponent.ɵfac = function JsonEditorComponent_Factory(t) { return new (t || JsonEditorComponent)(); };
JsonEditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: JsonEditorComponent, selectors: [["json-editor"]], viewQuery: function JsonEditorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.jsonEditorContainer = _t.first);
    } }, inputs: { options: "options", debug: "debug", data: "data" }, outputs: { change: "change", jsonChange: "jsonChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => JsonEditorComponent_1),
                multi: true
            }
        ])], decls: 2, vars: 1, consts: [[3, "id"], ["jsonEditorContainer", ""]], template: function JsonEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0, 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id);
    } }, encapsulation: 2, changeDetection: 0 });
__decorate([
    ViewChild('jsonEditorContainer', { static: true })
], JsonEditorComponent.prototype, "jsonEditorContainer", void 0);
__decorate([
    Input()
], JsonEditorComponent.prototype, "options", void 0);
__decorate([
    Input('data')
], JsonEditorComponent.prototype, "data", null);
__decorate([
    Input()
], JsonEditorComponent.prototype, "debug", void 0);
__decorate([
    Output()
], JsonEditorComponent.prototype, "change", void 0);
__decorate([
    Output()
], JsonEditorComponent.prototype, "jsonChange", void 0);

var NgJsonEditorModule_1;
let NgJsonEditorModule = NgJsonEditorModule_1 = class NgJsonEditorModule {
    static forRoot() {
        return {
            ngModule: NgJsonEditorModule_1,
            providers: []
        };
    }
};
NgJsonEditorModule.ɵfac = function NgJsonEditorModule_Factory(t) { return new (t || NgJsonEditorModule)(); };
NgJsonEditorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgJsonEditorModule });
NgJsonEditorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(JsonEditorComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'json-editor',
                template: `<div [id]="id" #jsonEditorContainer></div>`,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => JsonEditorComponent_1),
                        multi: true
                    }
                ],
                preserveWhitespaces: false,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { options: [{
            type: Input
        }], debug: [{
            type: Input
        }], change: [{
            type: Output
        }], jsonChange: [{
            type: Output
        }], data: [{
            type: Input,
            args: ['data']
        }], jsonEditorContainer: [{
            type: ViewChild,
            args: ['jsonEditorContainer', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgJsonEditorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule
                ],
                declarations: [
                    JsonEditorComponent
                ],
                exports: [
                    JsonEditorComponent
                ],
                schemas: [
                    CUSTOM_ELEMENTS_SCHEMA,
                    NO_ERRORS_SCHEMA
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgJsonEditorModule, { declarations: function () { return [JsonEditorComponent]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [JsonEditorComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { JsonEditorComponent, JsonEditorOptions, NgJsonEditorModule };

